// Startup session check (hard reload). Outcomes:
//   { user }            signed in
//   { signedOut: true } the server said no (401) and a refresh could not fix it
//   { unreachable: true } network error / 5xx / 429 after retries: the server
//                       did not answer, which is NOT a sign-out (a Render deploy
//                       or cold start returns 502/503 for a few seconds).
// A 401 other than TOKEN_EXPIRED (which the API client already refreshes) gets
// one refresh attempt, so a missing/stale access cookie with a valid refresh
// cookie does not sign the person out.
export async function checkSession({ getMe, refresh, sleep = (ms) => new Promise((r) => setTimeout(r, ms)), attempts = 3 }) {
  let refreshed = false;
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    try {
      const response = await getMe();
      return { user: response.data || {} };
    } catch (error) {
      const status = error && error.response && error.response.status;
      if (status === 401) {
        const code = error.response.data && error.response.data.code;
        if (refreshed || code === 'TOKEN_EXPIRED') return { signedOut: true };
        refreshed = true;
        try {
          await refresh();
        } catch (refreshError) {
          const rs = refreshError && refreshError.response && refreshError.response.status;
          if (rs && rs < 500 && rs !== 429) return { signedOut: true };
        }
        attempt -= 1; // the refresh retry does not use up a network attempt
        continue;
      }
      if (status && status < 500 && status !== 429) return { signedOut: true };
      if (attempt < attempts - 1) await sleep(1000 * (attempt + 1));
    }
  }
  return { unreachable: true };
}
